import { FC } from 'react'
import { RunStatus } from '../../types/types'
import { WorkflowStatusDef } from '../../utils/constants'
import { RunStatusCircle } from './StatusCircle'

type SubmissionStatusCellProps = {
  status: RunStatus
}

const SubmissionStatusCell: FC<SubmissionStatusCellProps> = ({ status }) => {
  return (
    <div className="flex items-center ">
      <RunStatusCircle status={status} />
      <div>{WorkflowStatusDef[status].name}</div>
    </div>
  )
}

export default SubmissionStatusCell
